import { render, staticRenderFns } from "./HomeHeader2.vue?vue&type=template&id=7074c537&scoped=true&"
import script from "./HomeHeader2.vue?vue&type=script&lang=js&"
export * from "./HomeHeader2.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeader2.vue?vue&type=style&index=0&id=7074c537&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074c537",
  null
  
)

export default component.exports